import { useState } from "react";
import { Sidebar as ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CarRentalOutlined from "@mui/icons-material/CarRentalOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <MenuItem
        active={selected === title}
        style={{
          color: colors.grey[100],
        }}
        onClick={() => setSelected(title)}
        icon={icon}
      >
        <Typography fontSize="13px" fontWeight="500">{title}</Typography>
      </MenuItem>
    </Link>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Tableau de Bord");

  const username = sessionStorage.getItem("username") || "Admin";
  const role = sessionStorage.getItem("role") || "superadmin";

  const menuItems = [
    { header: "Général" },
    { title: "Tableau de Bord", to: "/", icon: <HomeOutlinedIcon /> },
    { title: "Carte des Chauffeurs", to: "/drivers-map", icon: <MapOutlinedIcon /> },

    { header: "Passagers & Trajets" },
    { title: "Passagers", to: "/users", icon: <PeopleOutlinedIcon /> },
    { title: "Courses & Trajets", to: "/rides", icon: <CarRentalOutlined /> },

    { header: "Gestion Chauffeurs" },
    { title: "Chauffeurs", to: "/drivers", icon: <PersonOutlinedIcon /> },
    { title: "Vérification Dossiers", to: "/verification", icon: <VerifiedUserOutlinedIcon /> },
    { title: "Abonnements Chauffeurs", to: "/subscriptions", icon: <MonetizationOnOutlinedIcon /> },

    { header: "Finances & Facturation" },
    { title: "Paiements", to: "/payments", icon: <ReceiptOutlinedIcon /> },
    { title: "Factures & Quittances", to: "/invoices", icon: <ReceiptOutlinedIcon /> },

    { header: "Système & Sécurité" },
    { title: "Notifications Push", to: "/notification", icon: <NotificationsOutlinedIcon /> },
    { title: "Équipe Administrateurs", to: "/team", icon: <AdminPanelSettingsIcon /> },
    { title: "Paramètres Système", to: "/settings", icon: <SettingsOutlinedIcon /> },
  ];

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* HEADER / LOGO */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" fontWeight="bold" color={colors.greenAccent[500]}>
                  LinkerVTC
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="80px"
                  height="80px"
                  src={`/assets/user.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {username}
                </Typography>
                <Typography variant="body2" color={colors.greenAccent[500]} sx={{ textTransform: "uppercase", letterSpacing: "1px" }}>
                  {role}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            {menuItems.map((item, index) =>
              item.header ? (
                <Typography
                  key={index}
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px", fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px" }}
                >
                  {!isCollapsed && item.header}
                </Typography>
              ) : (
                <Item
                  key={index}
                  title={item.title}
                  to={item.to}
                  icon={item.icon}
                  selected={selected}
                  setSelected={setSelected}
                />
              )
            )}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
